'use strict';

const h = require('phy');

const setProps = bhw => {
  const props = { role: 'alert' };
  if (bhw) {
    Object.assign(props, {
      'data-bhw': bhw,
      'data-bh-viewport': 'respect',
    });
  }
  return props;
};

const showGuestCTAWidget = ({ notificationKlass, isLoggedIn }) => {
  return !(notificationKlass === '.error' || isLoggedIn);
};

const NotificationComponent = props => {
  const { bhw, messageText, notificationKlass, signInUrl, signInText } = props;
  return h(
    `${notificationKlass}`,
    setProps(bhw),
    h(
      '.text-message',
      messageText,
      showGuestCTAWidget(props)
        ? h(
            'a.sign-in-link',
            {
              'data-bhw': 'ClickToApplyPromoCodeSignIn',
              'data-bh-viewport': 'respect',
              href: signInUrl,
            },
            signInText
          )
        : null
    )
  );
};

module.exports = NotificationComponent;
